import { render, staticRenderFns } from "./TreeNode.vue?vue&type=template&id=2ba4cf56&"
import script from "./TreeNode.vue?vue&type=script&lang=ts&"
export * from "./TreeNode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports